import { useState, useEffect, FunctionComponent, } from 'react';
import { Button, Switch, Dialog } from '../../tailwindcomponents';
import { Typography, Input } from '../../tailwindcomponents';
import { Dictionary } from '../../components';
import { useSelector } from 'react-redux'
import { RootState } from '../../reducer';
import SubContractsApi from '../../api/subContracts';
import { dictionary } from '../../types/general';

type CertificateProps = {
    setLoading: Function
}

// Basic dictionary page using the dictionary component so easy to change style of all dictionary pages if needed.  
const EditCompanies: FunctionComponent<CertificateProps> = ({ setLoading }) => {
    const [companies, setCompanies] = useState(Array<dictionary>());
    const [newCompanyName, setNewCompanyName] = useState('');
    const [newCompanyDescription, setNewCompanyDescription] = useState('');
    const store = useSelector((state: RootState) => state);
    const currentUser = store.user.me;
    const [showActive, setShowActive] = useState(true);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [deleteReason, setDeleteReason] = useState('');
    const [selectedCompany, setSelectedCompany] = useState<dictionary | undefined>(undefined);

    useEffect(() => {
        refresh();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const refresh = () => {
        setLoading(true);
        SubContractsApi.GetAllCompanies().then(res => {
            setCompanies(res.data);
            setLoading(false);
        })
    }
    const onReasonEdit = (value: string) => {
        setDeleteReason(value);
    }
    const addCageCode = () => {
        SubContractsApi.AddNewCompany(currentUser.user_id, newCompanyName, newCompanyDescription).then(res => {
            refresh();
            setNewCompanyName('');
            setNewCompanyDescription('');
        })
    }
    const deleteCageCode = (cageCode: dictionary) => {
        setSelectedCompany(cageCode);
        setDeleteDialogOpen(true);
    }
    const confirmDelete = () => {
        if (selectedCompany !== undefined) {
            selectedCompany.deleted_reason = deleteReason;
            SubContractsApi.DeleteCompany(selectedCompany).then(res => {
                setSelectedCompany(undefined);
                refresh();
            })
        }
        setDeleteDialogOpen(false);
        setDeleteReason('');
    }

    return (
        <div>
            <div className="w-full flex flex-wrap items-start justify-center" >
                <div className="w-1/2">
                    <div className="w-full flex flex-wrap">
                        <div className="w-1/3 lg:w-2/3"></div>
                        <div className="w-1/6 lg:w-1/12">
                            <Typography text="Active" variant="subtitle2" color="textPrimary" margin={[1, 0, 0, 0]} />
                        </div>
                        <div className="w-1/6 lg:w-1/12">
                            <Switch
                                checked={!showActive}
                                onChange={() => setShowActive(!showActive)}
                                color="secondary"
                                name="checkedB"
                            />
                        </div>
                        <div className="w-1/6 lg:w-1/12">
                            <Typography text="Deleted" variant="subtitle2" color="textPrimary" margin={[1, 0, 0, 0]} />
                        </div>
                    </div>
                    <div className="w-5/6">
                        {
                            companies !== undefined && companies.filter(type => type.visible === showActive).map(row => (
                                <Dictionary name={row.name} object={row} deleted={showActive === true ? false : true} description={showActive === true ? row.description : row.deleted_reason} other={row.other} id={row.id} deleteProperty={(row: dictionary) => deleteCageCode(row)}></Dictionary>
                            ))
                        }
                    </div>
                </div>
                <Dialog
                    visible={deleteDialogOpen}
                    max_width={"md"} title={"Are you sure you want to delete this?"}
                    context={
                        <div>
                            <div className="flex justify-center w-full m-2 p-2">
                                <Input
                                    label_text={"Type a reason"} value={deleteReason} help_text=""
                                    onTextChange={(value: string) => onReasonEdit(value)} type="text" width={50} multiline={false} />
                            </div>
                            <div className="flex justify-center m-2 p-2">
                                <div className="p-2" >
                                    <Button variant="contained" color="primary" onClick={() => confirmDelete()}>Confirm delete</Button>
                                </div>
                                <div className="p-2">
                                    <Button variant="contained" color="secondary" onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
                                </div>
                            </div>
                        </div>
                    }
                    onClose={(status: any) => setDeleteDialogOpen(false)}
                    strict={false}
                    show_options={false}
                />
                <div className="w-5/12 flex flex-wrap">
                    <div className="w-full">
                        <br />
                        <Input
                            multiline={false}
                            label_text="Company Name"
                            help_text="Please type in a name for the new company"
                            type="text"
                            value={newCompanyName}
                            width={50}
                            onTextChange={(value: string) => setNewCompanyName(value)}
                        />
                    </div>
                    <br />
                    <div className="w-full">
                        <br />
                        <Input
                            multiline={false}
                            label_text="Description"
                            help_text="Please type in a descrption for the company"
                            type="text"
                            value={newCompanyDescription}
                            width={50}
                            onTextChange={(value: string) => setNewCompanyDescription(value)}
                        />
                    </div>
                    <br />
                    <Button variant="contained" color="primary" className="bg-accent text-[color:var(--ds-accent-fg)] text-sm" onClick={() => addCageCode()} >
                        Add Company
                    </Button>
                </div>
            </div>
        </div>
    );
};
export default EditCompanies;
